import FetchGetDataWithAuthNEW from "../services/FetchGetDataWithAuthNEW";

export default function FechGetReservationsBySearch(club, url) {

  var url = "/reservation/get_club_reservation_by_search/" + club + url;

  return FetchGetDataWithAuthNEW(url);
}

